import { TradingStatus } from 'api'
import { Translation } from 'locale'

export const tradingStatusTranslations = {
  [TradingStatus.ENABLED]: Translation.TC_ENABLED,
  [TradingStatus.DISABLED]: Translation.TC_DISABLED
}
